import {NgModule} from '@angular/core';
import {CapitalizePipe} from '@shared/pipes/capitalize.pipe';
import {ShortenPipe} from '@shared/pipes/shorten.pipe';
import {CalendarPipe} from '@shared/pipes/moment/calendar.pipe';
import {FromNowPipe} from '@shared/pipes/moment/from-now.pipe';
import {HasPermissionPipe} from '@shared/pipes/has-permission.pipe';
import {MoneyPipe} from '@shared/pipes/money.pipe';
import {ZeroifyPipe} from '@shared/pipes/zeroify.pipe';
import {DeCamelcasePipe} from '@shared/pipes/de-camelcase.pipe';
import {IntervalFormatterPipe} from '@shared/pipes/interval-formatter.pipe';
import {StripeYearPipe} from '@shared/pipes/stripe/stripe-year.pipe';
import {SorterPipe} from '@shared/pipes/sorter.pipe';
import {RoundPipe} from '@shared/pipes/round.pipe';

@NgModule({
  exports: [
    ShortenPipe, IntervalFormatterPipe, StripeYearPipe, CalendarPipe, RoundPipe,
    HasPermissionPipe, ZeroifyPipe, CapitalizePipe, DeCamelcasePipe, FromNowPipe, MoneyPipe, SorterPipe
  ],
  declarations: [
    CapitalizePipe, ShortenPipe, StripeYearPipe, CalendarPipe, IntervalFormatterPipe, FromNowPipe, RoundPipe,
    HasPermissionPipe, MoneyPipe, ZeroifyPipe, DeCamelcasePipe, SorterPipe
  ]
})

export class PipeModule {
}
